<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
    <hr>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["scode"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.scode" maxlength="10" >
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["sname"]}}</span>
          <input type="text" class="form-control"  v-bind:readonly='action=="View"' v-model="data.sname" maxlength="50">
        </div>
    </div>
    <div class="row">
        <div class="input-group col-md-7">
          <span class="input-group-addon" >{{rs["remark"]}}</span>
          <textarea v-bind:readonly='action=="View"' v-model="data.remark" 
                    rows="3" cols="30" type="text" class="form-control" maxlength="500" />
        </div>
    </div>
    <hr>
    <div class="row">
        <div class="input-group col-md-7">
          <span class="input-group-addon" >{{rs["formula"]}}</span>
          <textarea v-bind:readonly='action=="View"' v-model="data.formula"
                    rows="5" cols="30" type="text" class="form-control" maxlength="500" />
        </div>
    </div>
    
  </div>
</template>

<script>
import mixin from "@/fui/mixin";
export default {
  data(){
    return {
      paramList:[]
    }
  },
  methods: {
    checkInput(){
       if (!this.checkNull(this.data.scode, "nullId")) return false 
       if (!this.checkNull(this.data.sname, "nullName")) return false 
       return true
    },
    initParam(){
      alert((this.data.salaryFormula + " ").match(/\@(.*?) /g))
    }
  },
  mixins: [mixin.detail]
}
</script>
